<template>
  <div>
    <div class="main">
      <div class="head">{{ info }}変更</div>
      <!-- 选择修改密码方式 -->
      <div class="content" v-if="index == 0">
        <h2>認証方法をお選びください</h2>
        <ul>
          <li>
            <img src="../../../assets/img/pwd.png" alt />
            <span>パスワード認証 </span>
            <button @click="fn">確定</button>
          </li>
          <!-- <li>
            <img src="../../../assets/img/pwd.png" alt />
            <span>パスワード</span>
            <button>確定</button>
          </li>
          <li>
            <img src="../../../assets/img/email02.png" alt />
            <span>メール</span>
            <button>確定</button>
          </li> -->
        </ul>
      </div>
      <!-- 手机验证修改密码 -->
      <Pswd v-else-if="type == 'pswd'"></Pswd>
      <Email v-else-if="type == 'email'"></Email>
      <!-- <div class="content" v-else>
        <el-steps :active="active" finish-status="success">
          <el-step title="身分確認"></el-step>
          <el-step title="パスワード変更"></el-step>
          <el-step title="変更完了"></el-step>
        </el-steps>
        <h2>携帯番号</h2>
        <div class="changbox">
          <h3>
            携帯番号{{ $store.state.userInfo.data.mobile.substr(0, 3) }}****{{
              $store.state.userInfo.data.mobile.substr(7)
            }}
          </h3>
          <div class="form">
            <ol>
              <li class="yzm">
                <span>コード</span>
                <input type="text" v-model="editForm.Validation" />
                <p @click="sendValidation" v-if="show">確認コード送信</p>
                <p @change="sendValidation" v-else>
                  {{ Countdown }}秒後に再送信可能
                </p>
              </li>
              <li>
                <span>新規パスワード</span>
                <input type="text" v-model="editForm.newPwd" />
              </li>
              <li>
                <span>パスワード再確認</span>
                <input type="text" v-model="editForm.affirmPwd" />
              </li>
              <li class="btn">
                <button @click="phonePwd">次へ</button>
                <button @click="index = 0">その他の認証方法</button>
              </li>
            </ol>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { getNewPwd } from "../../../api/API/user";
import Pswd from "../../../components/pswd/password";
import Email from "../../../components/pswd/email";
export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      info: this.$route.query.type ? "メール" : "パスワード",
      type: "",
      active: 0,
      index: 0, // 索引
      show: true,
      num: "", // 随机生成6位数
      Countdown: 60, // 倒计时
      // 修改密码
      editForm: {
        Validation: "",
        newPwd: "",
        affirmPwd: "",
      },
    };
  },
  components: {
    Pswd,
    Email,
  },
  methods: {
    fn() {
      this.index = 1;
      if (this.$route.query.type == "email") {
        this.type = "email";
      } else {
        this.type = "pswd";
      }
      console.log(this.type);
    },
    // 发送验证码
    sendValidation() {
      for (var i = 0; i < 6; i++) {
        this.num += Math.floor(Math.random() * 10);
      }
      this.show = false;
      var timer = setInterval(() => {
        this.Countdown -= 1;
        if (this.Countdown <= 0) {
          this.show = true;
          this.Countdown = 60;
          clearInterval(timer);
        }
      }, 1000);
      console.log(this.num);
    },
    // 手机验证修改密码
    phonePwd() {
      if (this.editForm.Validation == "")
        return this.$message.warning("请验证码");

      if (this.editForm.Validation != this.num)
        return this.$message.warning("验证码输入错误");
      this.modification();
    },
    // 修改密码
    modification() {
      if (this.editForm.affirmPwd == "" || this.editForm.newPwd == "") {
        return this.$message.warning("请输入密码");
      }
      if (this.editForm.newPwd.length < 6 || this.editForm.newPwd.length > 18) {
        return this.$message.warning("密码长度");
      }
      if (this.editForm.affirmPwd != this.editForm.newPwd) {
        return this.$message.warning("两次的密码不一致");
      }
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "getNewPwd",
        token: this.token,
        password: this.editForm.newPwd,
      };
      getNewPwd(list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success("密码修改成功");
        this.index = 0;
      });
      console.log(this.editForm.newPwd.length);
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  .head {
    height: 40px;
    background: #eee;
    padding-left: 20px;
    line-height: 40px;
    color: #f3c622;
    font-size: 20px;
  }
  .content {
    padding: 80px 120px;
    border: 1px solid #ccc;
    h2 {
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 50px;
    }
    ul {
      li {
        height: 100px;
        border: 1px solid #ccc;
        padding: 30px 40px 0;
        margin-bottom: 50px;
        img {
          width: 58px;
          vertical-align: middle;
        }
        span {
          font-size: 18px;
          //   line-height: 58px;
          margin-left: 15px;
          font-weight: 700;
        }
        button {
          float: right;
          width: 120px;
          height: 40px;
          background: #f3c622;
          font-size: 18px;
          font-weight: 700;
          color: #fff;
          border-radius: 5px;
          margin-top: 15px;
          cursor: pointer;
        }
      }
    }
    .changbox {
      padding: 50px 80px;
      border: 1px solid #ccc;
      h3 {
        font-size: 20px;
        // border-bottom: 1PX solid #ccc;
      }
      ol {
        width: 800px;
        margin-left: 180px;
        li {
          height: 60px;
          line-height: 60px;
          span {
            display: inline-block;
            width: 150px;
            font-size: 16px;
          }
          input {
            width: 200px;
            height: 30px;
            border: 1px solid #ccc;
          }

          button {
            background-color: #f3c622;
            color: #fff;
            height: 32px;
            cursor: pointer;
          }
        }
        .btn {
          button {
            margin-left: 200px;
            border-radius: 5px;
            width: 100px;
          }
        }
        .yzm {
          height: 65px;
          p {
            line-height: 30px;
            width: 350px;
            text-align: right;
            margin-top: -20px;
            color: #f3c622;
            cursor: pointer;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>